export const JOB_EMPLOYMENT_TYPE_OPTIONS = ["Full-time", "Part-time", "Contract"];

export function normalizeEmploymentType(value = "") {
  const normalized = String(value ?? "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");

  if (!normalized) return "";
  if (normalized === "full-time" || normalized === "full time" || normalized === "fulltime") {
    return "Full-time";
  }
  if (normalized === "part-time" || normalized === "part time" || normalized === "parttime") {
    return "Part-time";
  }
  if (normalized === "contract") {
    return "Contract";
  }

  return "";
}

export function formatEmploymentType(value = "") {
  return normalizeEmploymentType(value) || String(value ?? "").trim();
}
